import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import {
	ONBOARDING_INTENT_EXPERIENCES,
	ONBOARDING_EXPERIENCES,
} from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadIntentBasedOnboardingState = (): Promise<{
	data: onboardingStateGetOnboardingStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: Object.values({
				...ONBOARDING_INTENT_EXPERIENCES,
				...ONBOARDING_EXPERIENCES,
			}),
		},
	});
};
